namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_settings, {
		
		padding: $mol_gap.block,

		Backup_time: {
			width: '44px',
		},

		Export: {
			margin: {
				top: '1rem',
			},
		},

		Restore: {
			Add: {
				backgroundColor: 'transparent',
				width: '100%',
				height: '1rem',
				justify: {
					content: 'flex-start'
				},
				Icon: {
					width: '1rem',
					height: '1rem',
				},
			},
		},

		Scale: {
			position: 'absolute',
			right: 0,
			top: 0,
		},

		Cut_map: {
			Trigger: {
				color: '#ff6666',
			},
			color: '#ff6666',
		},

		Description_field: {
			padding: {
				bottom: $mol_gap.block,
			},
		},
		
	} )
	
}
